import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import store  from './store/store';
import router from './routes';
import { Toaster } from './components/ui/toaster';
import { checkAuthStatus } from './store/slices/authSlice';
import { CSRFProvider } from './providers/CSRFProvider';

function App() {
  useEffect(() => {
    // Check auth status when app loads
    store.dispatch(checkAuthStatus());
  }, []);

  return (
    <Provider store={store}>
      <CSRFProvider>
        <RouterProvider router={router} />
        <Toaster />
      </CSRFProvider>
    </Provider>
  );
}

export default App;